import { Box, styled, SvgIconProps } from "@mui/material";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { FC } from "react";

export const TaskHeader = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0px 20px",
})) as typeof Box;

export const TaskHeaderTitle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  color: theme.palette.primary.main,
})) as typeof Box;

export const TaskHeaderVarifiedIcon: FC<SvgIconProps> = styled(
  CheckCircleOutlineIcon
)(({ theme }) => ({
  color: theme.palette.success.main,
}));

export const TaskHeaderUnvarifiedIcon: FC<SvgIconProps> = styled(
  PanoramaFishEyeIcon
)(({ theme }) => ({
  color: theme.palette.error.main,
}));
